
const iotReplaceRecordMoudle={
  namespaced: true,
  state:{
    searchSN:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default iotReplaceRecordMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/iotReplaceRecord.js